module.exports = __webpack_public_path__ + "static/media/how_it_works_ar.78d16cb6.jpg";